module.exports = __webpack_public_path__ + "img/undraw_wishlist_re_m7tv.1c625224.svg";